import { slices } from "@/constants/sliceNames";
import { createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";

import axiosIns from "../../axios/defaultAxios";
import { errorMessage } from "../actions/messages.actions";

const ENDPOINT = "batch-prediction/result";

/******* Get Batch prediction output ********/

export const requestBatchPredictionOutput = createAsyncThunk(
  `${slices.prediction}/requestBatchPredictionOutput`,
  async ({ folderPrefix, imageName, batchPredictionId, index }, { rejectWithValue, dispatch }) => {
    try {
      const query = _.omitBy(
        {
          folder_name: folderPrefix,
          image_name: imageName,
          index,
        },
        _.isNil
      );
      const response = await axiosIns.get(`${ENDPOINT}/${batchPredictionId}?${new URLSearchParams(query).toString()}`);
      return response.data.data;
    } catch (error) {
      dispatch(errorMessage(error?.response?.data?.error ?? error.message));
      return rejectWithValue(error?.response?.data?.error ?? error.message);
    }
  }
);

export const requestBatchPredictionOutputStatus = {
  [requestBatchPredictionOutput.fulfilled]: (state, action) => {
    state.loading = false;
    state.batchPredictionOutput = action.payload;
    // not sure of this one
    state.batchPredictionData = action.payload;
  },
  [requestBatchPredictionOutput.pending]: (state, action) => {
    state.loading = true;
  },
  [requestBatchPredictionOutput.rejected]: (state, action) => {
    state.loading = false;
    state.message = action.payload;
  },
};

/******* Refresh CSV output link ********/

export const requestRefreshCsvOutputLink = createAsyncThunk(
  `${slices.prediction}/requestRefreshCsvOutputLink`,
  async ({ folderPrefix, imageName, batchPredictionId }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axiosIns.get(
        `${ENDPOINT}/${batchPredictionId}?folder_name=${folderPrefix}&image_name=${imageName}`
      );
      return response.data.data;
    } catch (error) {
      dispatch(errorMessage(error?.response?.data?.error ?? error.message));
      return rejectWithValue(error?.response?.data?.error ?? error.message);
    }
  }
);

export const requestRefreshCsvOutputLinkStatus = {
  [requestRefreshCsvOutputLink.fulfilled]: (state, action) => {
    state.csvLoading = false;
    state.batchPredictionOutput.csv = action.payload.csv ?? action.payload.xlsx;
  },
  [requestRefreshCsvOutputLink.pending]: (state, action) => {
    state.csvLoading = true;
  },
  [requestRefreshCsvOutputLink.rejected]: (state, action) => {
    state.csvLoading = false;
    state.message = action.payload;
  },
};

/******* Get single prediction output ********/

export const requestSinglePredictionOutput = createAsyncThunk(
  `${slices.prediction}/requestSinglePredictionOutput`,
  async ({ folderPrefix, batchPredictionId }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axiosIns.get(
        `appexecutions/v2/prediction/result/${batchPredictionId}?folder_name=${folderPrefix}`
      );
      return response.data.data;
    } catch (error) {
      dispatch(errorMessage(error?.response?.data?.error ?? error.message));
      return rejectWithValue(error?.response?.data?.error ?? error.message);
    }
  }
);

export const requestSinglePredictionOutputStatus = {
  [requestSinglePredictionOutput.fulfilled]: (state, action) => {
    state.loading = false;
    state.singlePredictionOutput = action.payload;
  },
  [requestSinglePredictionOutput.pending]: (state, action) => {
    state.loading = true;
  },
  [requestSinglePredictionOutput.rejected]: (state, action) => {
    state.loading = false;
    state.message = action.payload;
  },
};

export const requestImageFilter = createAsyncThunk(
  `${slices.prediction}/requestImageFilter`,
  async ({ image, filterType, boxesInfo }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axiosIns.post("/image-processing/apply-filter", {
        image_url: image,
        filter_type: filterType,
        boxes_info: boxesInfo,
      });
      return response.data?.data;
    } catch (error) {
      dispatch(errorMessage(error?.response?.data?.error ?? error.message));
      return rejectWithValue(error?.response?.data?.error ?? error.message);
    }
  }
);

export const requestImageFilterStatus = {
  [requestImageFilter.fulfilled]: (state, action) => {
    state.loading = false;
  },
  [requestImageFilter.pending]: (state, action) => {
    state.loading = true;
  },
  [requestImageFilter.rejected]: (state, action) => {
    state.loading = false;
  },
};
